export const isCtrlPressed = (e) => e.ctrlKey === true
export const isShiftPressed = (e) => e.shiftKey === true
export const isAltPressed = (e) => e.altKey === true
export const isMetaPressed = (e) => e.metaKey === true



// WEBPACK FOOTER //
// ./web/js/keyHandlers/keyModifiersHelper.js